<script>
import Empty from './empty'
// import { defineAsyncComponent } from 'vue'
// const Empty = defineAsyncComponent(() => import('./empty.vue'))
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import axios from 'axios'
import config from './../config.js'
import Dropdown from "@/components/Form/components/classic-form-input/dropdown.vue";
import Input from "@/components/Form/components/classic-form-input/input.vue";

export default {
    props: ['value', 'theme', 'fieldLabel', 'hasError', 'showLabel', 'rules', 'className', 'type', 'dontIncludeSubdistrict', 'placeholder','addressVal', 'dontIncludeZipcode','shippingData'],
    data() {
        return {
            baseUrl: config.api.replace('/api', ''),
            searchData: '',
            autofillLoading: false,
            AutofillData: [],
            payload: {
                customerAUTOFILL: '', 
                customerFULL_AUTOFILL: "",
                PROVINCE: '',
                DISTRICT: '',
                SUBDISTRICT: '',
                CITY: '',
                ZIP: '',
                ORIGIN_CODE: '',
                CODE_SAP:'',
                DESTINATION_CODE_SI: '',
                ORIGIN_CODE_SI: '',
                closedSi: '',
                unsupportedSi: '',
                CITY_NAME_SI: '',
            }
        };
    },
    mounted() {
      
        const city=[],district=[],province=[];
        const params={ groupBy: this.apiGroupBy };
        if(this.shippingData && this.shippingData.enableExcludeShipping && this.shippingData.excludeShippingLocation && this.shippingData.excludeShippingLocation.length>0){
            this.shippingData.excludeShippingLocation.map(item=>{
                if(item.type=='province'){
                    province.push(item.PROVINCE_NAME);
                }else if(item.type=='city'){
                    city.push(item.item.CITY_NAME);
                }else if(item.type=='district'){
                    district.push(item.item.DISTRICT_NAME);
                }
            })
            params['province']=province.join(",");
            params['city']=city.join(",");
            params['district']=district.join(",")
            params['excludeShipping']=this.shippingData.excludeShipping;     
            params['excludeShippingLocation']=this.shippingData.excludeShippingLocation;
        }
        this.handleAutofill = debounce(async function (val) {
            this.autofillLoading = true
            this.AutofillData = []
            let autofill = await axios.post(this.baseUrl + this.apiUrl, { keyword: val, ...params });
            this.AutofillData = autofill.data.success ? autofill.data.data : []
            this.autofillLoading = false
        }, 500);
        if(this.addressVal && this.addressVal.customerAUTOFILL) {
           this.payload =  this.addressVal
        }
    },
    watch: {
        addressVal(val){           
            if(val){
                this.handleAutofill(val.customerAUTOFILL)
                this.payload =  val
            }          
        },
        'payload.customerAUTOFILL': {
            async handler() {  
                this.changeDestinationCode()
            }
        },
        'searchData': {
            async handler(val) {
                if (val.length > 3) {
                    this.handleAutofill(val)
                }
            }
        },
        value: {
            handler(defaultValue) {
                // for default selected from abandoned checkout
                if (defaultValue && this.AutofillData.length === 0) {
                    this.payload = cloneDeep(defaultValue)
                }
            },
            deep: true,
        }
    },
    computed: {
        options() {
            return this.AutofillData.map(opt => ({
                label: this.mapAddressName(opt),
                value: opt._id,
            }))
        },
        apiUrl() {
            return this.dontIncludeSubdistrict ? 'api/address/autofill/district' : 'api/address/autofill';
        },
        apiGroupBy() {
            return this.dontIncludeSubdistrict ? 'DISTRICT_NAME' : 'SUBDISTRICT_NAME';
        }
    },
    methods: {
        onClick(){           
            setTimeout(()=>{               
                this.$refs.orderInput && this.$refs.orderInput.$el.querySelector("input").focus();
                // this.payload.customerAUTOFILL="";
                // this.payload.customerFULL_AUTOFILL="";
                // this.$emit('onChange', null)
               
            },200);  
            this.searchData="";
            // if (this.searchData.length > 3) {
            //     this.handleAutofill(this.searchData)
            // }        
        },
        mapAddressName(data) {
            return data.PROVINCE_NAME + ', ' + data.CITY_NAME + ', ' + data.DISTRICT_NAME + (this.dontIncludeSubdistrict ? "" : ', ' + data.SUBDISTRICT_NAME) + (this.dontIncludeZipcode ? "" : ' - ' + data.ZIP_CODE)
        },
        changeDestinationCode() {
            let val = this.payload.customerAUTOFILL
            if (this.AutofillData.length) {
                let find = this.AutofillData.find(one => one._id == val)
                if (find) {
                    this.payload.SUBDISTRICT = find.SUBDISTRICT_NAME
                    this.payload.DISTRICT = find.DISTRICT_NAME
                    this.payload.PROVINCE= find.PROVINCE_NAME
                    this.payload.CITY = find.CITY_NAME
                    this.payload.ZIP = find.ZIP_CODE
                    
                        this.payload.DESTINATION_CODE_SI = find.DESTINATION_CODE_SI
                        this.payload.ORIGIN_CODE_SI = find.ORIGIN_CODE_SI
                        this.payload.closedSi = find.closedSi
                        this.payload.unsupportedSi = find.unsupportedSi
                        this.payload.CITY_NAME_SI = find.CITY_NAME_SI
                    
                        this.payload.DESTINATION_CODE = find.DESTINATION_CODE
                        this.payload.ORIGIN_CODE = find.ORIGIN_CODE

                        this.payload.CODE_SAP = find.CODE_SAP
                    
                    if (find.PROVINCE_NAME && find.CITY_NAME && find.DISTRICT_NAME) {
                        this.payload.customerFULL_AUTOFILL = [
                            find.PROVINCE_NAME,
                            find.CITY_NAME,
                            find.DISTRICT_NAME,
                            !this.dontIncludeSubdistrict && find.SUBDISTRICT_NAME
                        ].filter(Boolean).join(', ') + (this.dontIncludeZipcode ? '' : ` - ${find.ZIP_CODE}`);
                    }
                    this.$emit('onChange', this.payload)
                    //this.getEstimate()
                }
            }
        },
    },
    components: {
        Empty,
        Dropdown,
        Input,
    },
};
</script>

<template>
  <div id="address-fill">
    <Dropdown
        v-if="theme !== 'tuktuk'"
        v-model="payload.customerAUTOFILL"
        :placeholder="placeholder"
        :rules="rules"
        :options="options"
        :label="showLabel ? fieldLabel : undefined"
        :name="fieldLabel"
        @opened="onClick"
        :use-bottom-sheet="$device ? $device.isMobile : false"
        bottomSheetTitle="Pilih Kota / Kecamatan"
        bottomSheetClass="bottom-sheet__address-fill"
        :required="(rules || '').includes('required')"
    >
        <template #trigger="{ displayedValue }">
            <span>{{ payload.customerFULL_AUTOFILL || displayedValue }}</span>
        </template>
        <template #before-items>
            <Input ref='orderInput' class='device-ios w-100' v-model="searchData" type="text" />
        </template>
        <template #after-items>
            <span v-if="options.length === 0" class="address-search-placeholder">
                {{ autofillLoading
                    ? 'Searching...'
                    : searchData
                      ? 'Data tidak ditemukan'
                      : 'Ketik nama Kota/Kabupaten (minimal 4 huruf)'
                }}
            </span>
        </template>
    </Dropdown>

    <template v-if="theme === 'tuktuk'">
      <div class='select-value-label'>{{payload.customerFULL_AUTOFILL}}</div>
      <vs-select
          class='vs-form-control'
          :placeholder='placeholder'
          @focus='onClick'
          @click='onClick'
          :class="className"
          v-model="payload.customerAUTOFILL"
      >
          <vs-input ref='orderInput' class='vs-form-control device-ios' v-model="searchData" type="text" />
          <empty v-if='searchData.length < 4' :classProp='"p-1"' style="color: #6c757d; font-size: 14.5px;" :data="$t('common.AddressSearch')"/>
          <empty v-else-if='autofillLoading' :classProp='"p-1"' style="color: #6c757d; font-size: 14.5px;" :data="'Searching'"/>
          <empty v-else-if="AutofillData.length < 1" :classProp="'p-1'" :data="'Data tidak ditemukan'" />
          <vs-option :key='opt._id' v-for='opt in AutofillData' :label="opt.PROVINCE_NAME" :text="opt.PROVINCE_NAME" :value='opt._id' style="font-size: 14.5px;">
              {{ [
                  opt.PROVINCE_NAME,
                  opt.CITY_NAME,
                  opt.DISTRICT_NAME,
                  !dontIncludeSubdistrict && opt.SUBDISTRICT_NAME
              ].filter(Boolean).join(', ') + (dontIncludeZipcode ? '' : ` - ${opt.ZIP_CODE}`) }}
          </vs-option>
      </vs-select> 
    </template>
  </div>
</template>

<style lang="scss" scoped>
#address-fill {
    &::v-deep {
        .classic-form__dropdown {
            label {
                opacity: 1 !important;
            }
            &__trigger {
                height: 44px !important;
                &::after {
                    background-position: right 8px top 10px !important;
                }
            }
            .classic-form__input {
                input {
                    font-size: 14px !important;
                    height: 40px !important;
                    padding: 10px 36px 10px 12px !important;
                    background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.1057 14.688L17 17.488M16.0667 10.0214C16.0667 13.6296 13.1416 16.5547 9.53333 16.5547C5.92507 16.5547 3 13.6296 3 10.0214C3 6.41311 5.92507 3.48804 9.53333 3.48804C13.1416 3.48804 16.0667 6.41311 16.0667 10.0214Z' stroke='%236C7E95' stroke-linecap='round'/%3E%3C/svg%3E%0A") !important;
                    background-position: right 12px top 10px !important;
                    background-repeat: no-repeat !important;
                    outline-color: #E0E9F4 !important;
                    outline-width: 1px !important;
                    outline-offset: -1px !important;
                    box-shadow: 0px 1px 2px 0px #1018280D;
                }
            }
            .address-search-placeholder {
                margin-top: 6px;
                color: #6C7E95;
                font-size: 12px;
                font-weight: 400;
                line-height: 18px;
            }
        }
    }
}
</style>

<style lang="scss">
.bottom-sheet__address-fill {
    .classic-form__input {
        input {
            font-size: 14px !important;
            height: 40px !important;
            padding: 10px 36px 10px 12px !important;
            background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.1057 14.688L17 17.488M16.0667 10.0214C16.0667 13.6296 13.1416 16.5547 9.53333 16.5547C5.92507 16.5547 3 13.6296 3 10.0214C3 6.41311 5.92507 3.48804 9.53333 3.48804C13.1416 3.48804 16.0667 6.41311 16.0667 10.0214Z' stroke='%236C7E95' stroke-linecap='round'/%3E%3C/svg%3E%0A") !important;
            background-position: right 12px top 10px !important;
            background-repeat: no-repeat !important;
            outline-color: #E0E9F4 !important;
            outline-width: 1px !important;
            outline-offset: -1px !important;
            box-shadow: 0px 1px 2px 0px #1018280D;

            &:focus {
            outline-color: #E0E9F4 !important;
            }
        }
    }
    .address-search-placeholder {
        margin-top: 6px;
    }
    .device-ios {
      input {
        font-size: 16px !important;
      }
    }
}
</style>
